/**
 * Chat utility functions for message formatting and processing
 */

/**
 * Format message history to match the API expected format
 * @param {Array} messages - Array of message objects with role and content properties
 * @returns {Array} - Formatted message history for API consumption
 */
export const formatMessageHistory = (messages = []) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    return [];
  }
  
  // Map to standard format expected by API
  return messages.map(msg => ({
    role: msg.role || (msg.sender === 'user' ? 'user' : 'assistant'),
    content: msg.content || msg.text || msg.message || ''
  }));
};

/**
 * Generate a unique session ID for chat sessions
 * @returns {string} - UUID for chat session
 */
export const generateSessionId = () => {
  return crypto.randomUUID();
};

/**
 * Format timestamp for chat messages
 * @param {Date|string} date - Date object or date string
 * @returns {string} - Formatted time string (HH:MM)
 */
export const formatMessageTime = (date) => {
  return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export default {
  formatMessageHistory,
  generateSessionId,
  formatMessageTime
};
/**
 * Une conversation est fermee quand SON statut l'est. Le ticket, lui, se ferme aussi
 * quand la conversation repasse en mode IA : s'y fier affichait « Conversation
 * fermee » alors que l'IA continuait de repondre dans la meme conversation.
 * Sans statut de conversation (ancienne API), on garde l'ancien comportement.
 */
export const isConversationClosed = (ticket) => {
    if (!ticket || ticket.status !== 'CLOSED') return false;
    const status = String(ticket.conversation_status || '').toUpperCase();
    return !status || ['CLOSED', 'RESOLVED', 'UNSOLVED'].includes(status);
};
